<template>
  <v-container class="survey-integrations" fluid>
    <page-title title="Integrations"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <StorefrontManager
      widget-type="feedback"
      title="Shopify storefront app"
      subtitle="Connect Shopify stores to this survey, choose the campaign from a real dropdown, set storefront defaults, and validate the live embed before enabling the app block."
      target-placeholder="#loyagram-root"
    />
    <ZapierManager title="Zapier automation"></ZapierManager>
  </v-container>
</template>

<script>
import Tabs from '@/components/Tabs'
import StorefrontManager from '@/components/shopify/StorefrontManager'
import ZapierManager from '@/components/integrations/ZapierManager'
import routes from '@/route_names'

export default {
  name: 'SurveyIntegrationsView',
  components: { StorefrontManager, Tabs, ZapierManager },
  computed: {
    tabSettings() {
      return {
        preselected: null,
        tabs: [
          {
            id: routes.SURVEY_SETTINGS,
            label: 'Settings'
          },
          {
            id: routes.SURVEY_INTEGRATIONS,
            label: 'Integrations'
          },
          {
            id: routes.SURVEY_PUBLISH,
            label: 'Publish'
          }
        ]
      }
    }
  }
}
</script>
